import { Badge } from "@chakra-ui/react";
import { TicketPriority } from "../types/ticket.types";
import i18n from "../i18n";

const TicketPriorityBadge = ({ priority }: { priority: TicketPriority }) => {
  const ticketPriorityBackgroundColors = new Map<TicketPriority, string>([
    [TicketPriority.LOW, "green.50"],
    [TicketPriority.MEDIUM, "orange.50"],
    [TicketPriority.HIGH, "red.50"],
  ]);
  const ticketPriorityColors = new Map<TicketPriority, string>([
    [TicketPriority.LOW, "green.700"],
    [TicketPriority.MEDIUM, "orange.700"],
    [TicketPriority.HIGH, "red.700"],
  ]);
  const ticketPriorityBorderColors = new Map<TicketPriority, string>([
    [TicketPriority.LOW, "green.300"],
    [TicketPriority.MEDIUM, "orange.300"],
    [TicketPriority.HIGH, "red.300"],
  ]);

  return (
    <Badge
      h="1.5rem"
      lineHeight="1.5rem"
      px="1rem"
      rounded="xl"
      backgroundColor={
        ticketPriorityBackgroundColors.get(priority) ?? "gray.50"
      }
      color={ticketPriorityColors.get(priority) ?? "gray.700"}
      border={"solid 1px"}
      borderColor={ticketPriorityBorderColors.get(priority) ?? "gray.300"}
      textTransform={"capitalize"}
      w="fit-content"
    >
      {i18n.t(`ticket.priority.${priority}`)}
    </Badge>
  );
};

export default TicketPriorityBadge;
